module.exports = __webpack_public_path__ + "static/media/user-icon-2.e73dc92b.svg";